import type { MerchantApiClient } from "../../types.js";
import type { MerchantDashboardDto, MerchantDashboardFilters } from "./models.js";

interface DataEnvelope<T> {
  data: T;
  meta: {
    requestId: string;
  };
}

export interface MerchantDashboardApi {
  getDashboard(filters: MerchantDashboardFilters): Promise<MerchantDashboardDto>;
}

export function createMerchantDashboardApi(client: MerchantApiClient): MerchantDashboardApi {
  return {
    async getDashboard(filters) {
      const envelope = await client.get<DataEnvelope<MerchantDashboardDto>>(
        `/v1/api/dashboard?${query(filters)}`,
      );
      return envelope.data;
    },
  };
}

function query(filters: MerchantDashboardFilters): string {
  return new URLSearchParams(
    Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== "")
      .map(([key, value]) => [key, String(value)]),
  ).toString();
}
